import { render, staticRenderFns } from "./ParameterDataType.vue?vue&type=template&id=8fd3ae18&scoped=true&"
import script from "./ParameterDataType.vue?vue&type=script&lang=js&"
export * from "./ParameterDataType.vue?vue&type=script&lang=js&"
import style0 from "./ParameterDataType.vue?vue&type=style&index=0&id=8fd3ae18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd3ae18",
  null
  
)

export default component.exports